import React from 'react';
import {connect} from 'react-redux';

import * as BetTypeMap from 'constants/BetType';

import BetSlip from './BetSlip.jsx';
import BetSlipExt from './BetSlipeExt.jsx';

class BetSlipList extends React.Component {
    static propTypes = {
        betSlips: React.PropTypes.object.isRequired,
        currentBetTypeIndex: React.PropTypes.number.isRequired,
        betTypes: React.PropTypes.object.isRequired,
        onUpdateSize: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    static renderBetSlipExt(betSlipId, onUpdateSize) {
        return (<BetSlipExt key={betSlipId} id={betSlipId} onUpdateSize={onUpdateSize}/>);
    }

    static renderBetSlip(betSlipId, onUpdateSize) {
        return (<BetSlip key={betSlipId} id={betSlipId} onUpdateSize={onUpdateSize}/>);
    }

    render() {
        const {currentBetTypeIndex, betTypes} = this.props;
        const betSlips = this.props.betSlips.reverse().keySeq();
        const betType = betTypes.get(currentBetTypeIndex) || {};
        const isMultiSingleSlip = (betSlips.size > 1 && betType.type === BetTypeMap.SINGLE);

        return (
            <ul className="coupons-list">
                {!isMultiSingleSlip && betSlips.map(betSlipId => BetSlipList.renderBetSlip(betSlipId, this.props.onUpdateSize))}
                {isMultiSingleSlip && betSlips.map(betSlipId => BetSlipList.renderBetSlipExt(betSlipId, this.props.onUpdateSize))}
            </ul>
        );
    }
}

function select(state) {
    const betSlips = state.application.getIn(['coupon', 'betSlips']);
    const currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
    const betTypes = state.application.getIn(['coupon', 'betTypes']);

    return {
        betSlips,
        currentBetTypeIndex,
        betTypes
    };
}

export default connect(select)(BetSlipList);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/BetSlipList.jsx